const zipCodeValidator = (zipCode) => {
  const zipCodeRegex = /^\d{4}$/;

  return zipCodeRegex.test(zipCode);
};

export default zipCodeValidator;
